import React, { Fragment, ReactElement } from "react";
import Styles from './InputTextIcon.module.scss';

interface InputTextIconProps {
  id: string,
  name: string,
  value: string,
  onBlur: any,
  onChange: any,
  onKeyDown?: any,
  onKeyUp?: any,
  onKeyPress?: any,
  placeholder : string,
  styleClass?: string,
  icon: ReactElement,
  type: string,
  tabIndex?: number,
  disabled?: boolean,
  maxLength?: number
}
const InputTextIcon: React.FC<InputTextIconProps> = (props: InputTextIconProps) => {
  const { styleClass, icon, ...rest } = props;

  return (
    <Fragment>
      <div className={Styles.inputGroup}>
        <div className={Styles.icon}>
            {icon}
        </div>
        <input
          className={Styles.inputIcon + " " + styleClass}
          {...rest}
        />
    </div>
    </Fragment>
  );
};

export default InputTextIcon;